module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("捐赠")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.patreon.com/airyland"
    }
  }, [_vm._v("Patreon")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://paypal.me/airyland"
    }
  }, [_vm._v("PayPal")])]), _vm._v(" "), _c('li', [_vm._v("支付宝 airyland@qq.com")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-92f50bc0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-92f50bc0"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/donate-149.vue
// module id = 2393
// module chunks = 441